import React, { forwardRef } from 'react'

import * as S from './styles'

import { FormItem } from '../FormItem'

import type { ToggleInputProps } from './types'

/**
 * Form toggle component
 * @component
 * @param {string} label - label at the right side of the toggle
 * @param {string} name - form field key
 * @param {boolean} isLocked - input disabled and lock icon is visible
 * @example
 * import { useForm } from 'react-hook-form'
 * const { register } = useForm()
 *
 * <Toggle {...register('isAgreementSigned')} label="Agreement" />
 */

export const Toggle: React.FC<ToggleInputProps> = forwardRef<
  HTMLInputElement,
  ToggleInputProps
>(
  (
    { className, label, name, isLocked = false, disabled, ...restProps },
    ref
  ) => (
    <FormItem>
      <S.ToggleContainer $disabled={disabled} className={className}>
        <S.Toggle>
          <input
            ref={ref}
            name={name}
            type="checkbox"
            disabled={isLocked || disabled}
            {...restProps}
          />
          <span />
          {isLocked && <S.LockIcon />}
        </S.Toggle>
        <S.ToggleCaptionContainer>{label}</S.ToggleCaptionContainer>
      </S.ToggleContainer>
    </FormItem>
  )
)

Toggle.displayName = 'Toggle'
